export interface UserAudioSample {
  id: string;
  userAudioTrackId: string;
  uploadId: string;
  status: string;
  tags: Label[]
  createdAt: string;
  uploads: {
    url: string;
  };
}

interface Label {
  key: string;
  value: string;
}

export interface UserAudio {
  id: string;
  userId: string;
  name: string;
  thirdPartyIdentifier: string;
  modelName?: string;
  isPublic: boolean;
  deleted: boolean;
  createdAt: string;
  updatedAt: string;
  userAudioSample: UserAudioSample[];
}

export enum BufferType {
  Buffer = 'Buffer',
}

export interface AudioPreview {
  data: number[];
  type: BufferType;
}

export interface AudioCredit {
  availableCredits: number;
  creditsInUse: number;
  requiredCredits: number;
}
